type PhotoWithTags = { tags?: string[] };

/**
 * Returns the 1-based positions of photos missing at least one tag. The API
 * rejects empty tags with a 400, so the submit flows use this to block an
 * invalid payload when the step validation was somehow bypassed.
 */
export function findPhotosWithoutTags(photos?: PhotoWithTags[]): number[] {
  return (photos || [])
    .map((photo, index) => ({ photo, index }))
    .filter(({ photo }) => !photo.tags || photo.tags.length === 0)
    .map(({ index }) => index + 1);
}

/**
 * Builds the pt-BR error message for photos missing tags, or null when all
 * photos are tagged.
 */
export function photosWithoutTagsMessage(
  photos?: PhotoWithTags[],
): string | null {
  const positions = findPhotosWithoutTags(photos);
  if (positions.length === 0) {
    return null;
  }
  return positions.length === 1
    ? `Foto ${positions[0]}: adicione pelo menos uma tag.`
    : `Fotos ${positions.join(", ")}: adicione pelo menos uma tag em cada.`;
}
